<template>
<div class="insurance-ocr-dialog-box">
  <el-dialog
    class="insurance-ocr-dialog"
    :visible.sync="visible"
    :show-close="false"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    top="50%"
    @close="closeModal">
    <div class="dialog-header" slot="title">
      <div class="title">上传证件</div>
      <div class="status-box">
        <div class="status-item">
          成功: {{uploadSuccessTotal}} 张
        </div>
        <div class="status-item">
          失败: {{uploadErrorTotal}} 张
        </div>
        <div class="status-item">
          识别中: {{uploadingTotal}} 张
        </div>
      </div>
      <div class="close" @click="closeModal">
        <i class="el-icon el-icon-close"></i>
      </div>
    </div>
    <div class="dialog-content">
      <input type="file" class="upload-input" accept="image/png, image/jpeg" multiple="multiple" @change="submitUpload">
      <input type="file" class="reupload-input" accept="image/png, image/jpeg" @change="submitReupload">

      <div class="not-upload-wrap" v-if="!uploadList.length">
        <div class="not-upload-box" @click="startUpload">
          <img class="add-icon" src="../../../assets/imgs/insurance-new/icon-add-img.png" alt="">
          <div class="not-upload-title">点击上传图片</div>
          <div class="not-upload-tips">支持jpg/png格式，每张图不超过10M</div>
        </div>
      </div>
      <div class="upload-box" v-else>
        <div class="upload-error-box" v-if="uploadErrorList.length">
          <div class="upload-error-list">
            <div class="upload-error-item" v-for="item in uploadErrorList" :key="item.id">
              <div @click="deleteUpload(item.id)" class="icon-close"></div>
              <div class="item-img-box" @click="openImageReview(item.recognizeData.url || item.original_url)">
                <img :src="item.recognizeData.url || item.original_url" class="item-img" />

                <div v-if="item.status !== 0" class="review-box" @click="openImageReview(item.recognizeData.url || item.original_url)">
                  <img src="../../../assets/imgs/insurance-new/review-icon.png" class="review-icon" alt="">
                  <div class="review-label">查看</div>
                </div>
              </div>
              <div class="error-msg">
                <img src="../../../assets/imgs/insurance-new/icon-error.png" class="error-icon" alt="">
                <div class="msg-text">证件识别失败</div>
              </div>
              <div class="reupload-btn" @click="reupload(item.id)">重新上传</div>
            </div>
          </div>
        </div>
        <div class="upload-success-box">
          <div class="upload-success-list">
            <div class="upload-item" v-for="item in uploadOtherList" :key="item.id" v-loading="item.status === 0">
              <div @click="deleteUpload(item.id)" class="icon-close"></div>
              <div class="item-img-box">
                <img :src="item.recognizeData.url || item.original_url" class="item-img" />
                <div class="item-type" v-if="item.status === 1">{{{1: '身份证', 2: '护照'}[item.type]}}</div>

                <div v-if="item.status !== 0" class="review-box" @click="openImageReview(item.recognizeData.url || item.original_url)">
                  <img src="../../../assets/imgs/insurance-new/review-icon.png" class="review-icon" alt="">
                  <div class="review-label">查看</div>
                </div>
              </div>
              <div class="item-name" v-if="item.status === 1 && item.recognizeData.fullname">姓名: {{item.recognizeData.fullname}}</div>
            </div>
            <div class="upload-new-item" @click="startUpload">
              <img class="add-icon" src="../../../assets/imgs/insurance-new/icon-add-img.png" alt="">
              <div class="upload-label">点击上传图片</div>
              <div class="upload-tips">支持jpg/png格式<br />每张图不超过10M</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog-footer" slot="footer">
      <div class="tips">
        <img class="icon" src="../../../assets/imgs/insurance-new/icon-tips-gray.png" alt="">
        <div class="text">请拍摄上传彩色的护照首页/身份证（人像面），字体清晰可见，无反光，无遮挡，无水印</div>
      </div>
      <div class="btn-box">
        <button class="clear-btn" @click="clearAll">清空</button>
        <button @click="submit" class="save-btn" :disabled="!allowSubmitBtn">保存</button>
      </div>
    </div>
  </el-dialog>
  <!-- 图片预览 -->
  <el-dialog
    id="ocr-review-box"
    title="图片预览"
    :show-close="true"
    :modal="false"
    v-model="imageReviewDialog.open"
  >
    <img :src="imageReviewDialog.src" />
  </el-dialog>
</div>

</template>
<script>
import uploadFileService from '../../../services/upload-file-service.js';
import utils from '../../../libs/utils';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      visible: this.show,
      uploadList: [],
      id: 1,
      reuploadId: 0, // 重新上传的id
      imageReviewDialog: {
        open: false,
        src: '',
      },
      requestList: [], // 请求列表,用于批量发送请求，
      batchLoading: false,
    };
  },
  computed: {
    // 失败的upload
    uploadErrorList() {
      return this.uploadList.filter(item => item.status === 2);
    },
    // 除开失败其他的upload
    uploadOtherList() {
      return this.uploadList.filter(item => item.status !== 2);
    },
    uploadErrorTotal() {
      return this.uploadErrorList.length;
    },
    uploadingTotal() {
      return this.uploadList.filter(item => item.status === 0).length;
    },
    uploadSuccessTotal() {
      return this.uploadList.filter(item => item.status === 1).length;
    },
    // 存在上传成功的，且不存在上传中的，就允许按钮
    allowSubmitBtn() {
      return this.uploadSuccessTotal && this.uploadList.every(item => item.status !== 0);
    },
  },
  watch: {
    visible(newValue) {
      this.$emit('update:show', newValue);
    },
    show(val) {
      this.visible = val;
      if (val) {
        this.init();
      }
    },
  },
  created() {
    if (this.visible) {
      this.init();
    }
  },
  methods: {
    init() {
      this.uploadList = [];
      this.requestList = [];
    },
    closeModal() {
      this.visible = false;
    },
    clearAll() {
      this.init();
    },
    // 打开图片预览
    openImageReview(imageSrc) {
      this.imageReviewDialog.open = true;
      this.imageReviewDialog.src = imageSrc;
    },
    deleteUpload(id) {
      const index = this.uploadList.findIndex(item => item.id === id);
      if (index === -1) return;
      this.uploadList.splice(index, 1);

      const requestIndex = this.requestList.findIndex(item => item.id === id);
      if (requestIndex === -1) return;
      this.requestList.splice(index, 1);
    },
    startUpload() {
      this.$el.querySelector('.insurance-ocr-dialog .upload-input').click();
    },
    reupload(id) {
      this.reuploadId = id;
      this.$el.querySelector('.insurance-ocr-dialog .reupload-input').click();
    },
    // 提交重新上传
    submitReupload(e) {
      if (!(e.target.files && e.target.files.length > 0)) return;
      const file = e.target.files[0];
      if (file.size >= 10240000) {
        e.target.value = '';
        return utils.msg.warning('单个图片文件超过10M，请检查后重新上传');
      } else if (['image/jpeg', 'image/png'].indexOf(file.type) === -1) {
        return utils.msg.warning('仅支持 png、jpg 格式的图片');
      }
      // 删除旧的
      this.deleteUpload(this.reuploadId);
      // 添加一个新的
      const uploadItem = {
        id: this.id++,
        file,
        original_url: URL.createObjectURL(file),
        status: 0, // 0： 上传中， 1：识别成功，2、识别失败
        type: 0, // 1: 身份证 2：护照
        recognizeData: {},
      };
      this.uploadList.push(uploadItem);

      this.recognizeUpload(file)
        .then((res) => {
          // 识别成功
          uploadItem.type = res.type;
          uploadItem.recognizeData = res.data;
          uploadItem.status = 1;
        })
        .catch(() => {
          // 识别失败
          uploadItem.status = 2;
        });
      e.target.value = '';
    },
    submitUpload(e) {
      if (!(e.target.files && e.target.files.length > 0)) return;
      // 将选择的文件列表转为数组
      const filesArray = Array.from(e.target.files);
      if (filesArray.some(item => item.size >= 10240000)) {
        e.target.value = '';
        return utils.msg.warning('单个图片文件超过10M，请检查后重新上传');
      }
      // 上传前校验文件类型
      const typeError = filesArray.some(el => ['image/jpeg', 'image/png'].indexOf(el.type) === -1);
      if (typeError) {
        return utils.msg.warning('仅支持 png、jpg 格式的图片');
      }
      // const uploadPassportRequest = [];
      filesArray.forEach((file) => {
        const uploadItem = {
          id: this.id++,
          file,
          original_url: URL.createObjectURL(file),
          status: 0, // 0： 上传中， 1：识别成功，2、识别失败
          type: 0, // 1: 身份证 2：护照
          recognizeData: {},
        };
        this.uploadList.push(uploadItem);

        this.requestList.push(uploadItem);
      });
      // 识别图片
      this.batchUpload();
      e.target.value = '';
    },
    // 批量上传，十张十张传
    batchUpload(self) {
      if (this.requestList.length === 0) {
        this.batchLoading = false;
        return;
      }
      // 不是自身调用的，并且当前正在批量上传中，则直接返回，因为当前已经在上传中了
      if (!self && this.batchLoading) {
        return;
      }
      this.batchLoading = true;
      const currRequestList = this.requestList.splice(0, 10);
      const promiseAll = currRequestList.map(uploadItem => this.recognizeUpload(uploadItem.file).then((res) => {
        // 识别成功
        uploadItem.type = res.type;
        uploadItem.recognizeData = res.data || {};
        uploadItem.status = 1;
      }).catch(() => {
        // 识别失败
        uploadItem.status = 2;
      }));
      Promise.all(promiseAll).finally(() => {
        setTimeout(() => {
          this.batchUpload(true);
        }, 3000);
      });
    },

    recognizeUpload(file) {
      return uploadFileService.uploadOcrMaterial(file, 'idcarda', { noToast: true, zipImg: true })
        .then((data) => {
          if (!data.id_no && !data.fullname) {
          // 因为传身份证国徽面也可以返回数据，需要单独处理一下
            return Promise.reject();
          }
          return { type: 1, data };
        }).catch(() =>
        // 照片识别失败，识别护照
          uploadFileService.uploadOcrMaterial(file, 'passport', { noToast: true, zipImg: true })
            .then(data => ({ type: 2, data })),
        );
    },
    submit() {
      const uploadSuccessList = this.uploadList.filter(item => item.status === 1);
      this.$emit('submit', uploadSuccessList.map(item => ({
        cname: item.recognizeData.fullname || '',
        ename: '',
        card_type: item.type || '',
        card_code: (item.type === 2 ? item.recognizeData.passport_number : item.recognizeData.id_no) || '',
        sex: { 0: 1, 1: 0 }[item.recognizeData.gender],
        birthday: item.recognizeData.birthday ? new Date(item.recognizeData.birthday) : '',
      })));
    },
  },
};
</script>
<style lang="less" scoped>
.insurance-ocr-dialog-box{
  /deep/ .insurance-ocr-dialog .el-dialog{
    width: 1000px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0px 8px 12px 0px rgba(57, 61, 70, 0.06);
    border-radius: 4px;
    margin-bottom: 0;
    .el-dialog__header{
      padding: 0;
    }
    .el-dialog__body{
      padding: 0;
    }
    .el-dialog__footer{
      padding: 0;
    }
  }
  .dialog-header{
    height: 60px;
    padding: 0 24px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #E9EEF2;
    .title{
      font-size: 20px;
      color: #2F333D;
      font-weight: 600;
    }
    .status-box{
      margin-left: 20px;
      display: flex;
      align-items: center;
      flex-grow: 1;
      .status-item{
        margin-right: 24px;
        font-size: 14px;
        color: #444444;
        position: relative;
        &::after{
          content: "";
          width: 1px;
          height: 16px;
          background: #E9EEF2;
          position: absolute;
          right: -12px;
          top: 50%;
          transform: translateY(-50%);
        }
        &:last-child{
          &::after{
            display: none;
          }
        }
      }
    }
    .close{
      margin-left: 12px;
      flex-shrink: 0;
      cursor: pointer;
      color: #91999F;
      font-size: 18px;
    }
  }

  .dialog-content{
    height: 500px;
    overflow: auto;
    padding: 0 24px;
    line-height: 1;
    // 定义滚动条宽高及背景
    &::-webkit-scrollbar {
      width: 4px;
      background-color: #ffffff;
    }

    /*定义滚动条轨道*/
    &::-webkit-scrollbar-track {
      border-radius: 2px;
    }

    // 定义滚动条滑块
    &::-webkit-scrollbar-thumb {
      background-color: rgba(0,0,0,0.2);
      border-radius: 2px;

      &:hover {
        background-color: rgba(0,0,0,0.3);
      }
    }
    .upload-input, .reupload-input{
      position: absolute;
      z-index: -1;
      left: -9999px;
      top: 0;
      opacity: 0;
      width: 0;
      height: 0;
    }
    .not-upload-wrap{
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .not-upload-box{
        width: 300px;
        height: 180px;
        background: #F4FAFF;
        border: 1px dashed rgba(89, 159, 255, 0.4);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        cursor: pointer;
        .add-icon{
          width: 24px;
          height: 24px;
          margin-bottom: 20px;
        }
        .not-upload-title{
          color: #599FFF;
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 12px;
        }
        .not-upload-tips{
          color: #91999F;
          font-size: 12px;
        }
      }
    }

    .upload-box{
      .upload-error-box{
        padding: 24px 0;
        border-bottom: 1px solid #E9EEF2;
        overflow: hidden;
        .upload-error-list{
          display: flex;
          flex-wrap: wrap;
          margin-right: -34px;
          margin-bottom: -34px;
          .upload-error-item{
            width: 160px;
            height: 180px;
            border-radius: 2px;
            border: 1px solid rgba(244, 69, 92, 0.3);
            background: #FFF7F8;
            margin-right: 34px;
            margin-bottom: 34px;
            position: relative;
            padding: 10px 9px 0 9px;
            .icon-close{
              cursor: pointer;
              width: 20px;
              height: 20px;
              position: absolute;
              right: -10px;
              top: -10px;
              background: url(../../../assets/imgs/insurance-new/icon-close.png) no-repeat center / 100% 100%;
              &:hover{
                background: url(../../../assets/imgs/insurance-new/icon-close-hover.png) no-repeat center / 100% 100%;
              }
            }
            .item-img-box{
              margin-bottom: 10px;
              position: relative;
              font-size: 0;
              .item-img{
                width: 140px;
                height: 90px;
                border-radius: 2px;
              }
              .review-box{
                cursor: pointer;
                position: absolute;
                z-index: 4;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                background: rgba(47, 51, 61, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
                opacity: 0;
                &:hover{
                  opacity: 1;
                }
                .review-icon{
                  width: 14px;
                  height: 14px;
                  margin-right: 4px;
                }
                .review-label{
                  color: #fff;
                  font-size: 14px;
                }
              }
            }
            .error-msg{
              display: flex;
              align-items: center;
              margin-top: 2px;
              .error-icon{
                flex-shrink: 0;
                width: 16px;
                margin-right: 4px;
              }
              .msg-text{
                color: #F4455C;
                font-size: 14px;
              }
            }
            .reupload-btn{
              position: absolute;
              left: -1px;
              bottom: -1px;
              right: -1px;
              height: 40px;
              background: #599FFF;
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              font-size: 16px;
              color: #fff;
            }
          }
        }
      }

      .upload-success-box{
        padding: 24px 0;
        overflow: hidden;
        .upload-success-list{
          display: flex;
          flex-wrap: wrap;
          margin-right: -34px;
          margin-bottom: -34px;
          .upload-item{
            width: 160px;
            height: 146px;
            padding: 10px 9px;
            background: #FAFBFC;
            border: 1px solid #E9EEF2;
            border-radius: 2px;
            position: relative;
            z-index: 1;
            margin-right: 34px;
            margin-bottom: 34px;
            .icon-close{
              cursor: pointer;
              width: 20px;
              height: 20px;
              position: absolute;
              right: -10px;
              top: -10px;
              z-index: 3;
              background: url(../../../assets/imgs/insurance-new/icon-close.png) no-repeat center / 100% 100%;
              &:hover{
                background: url(../../../assets/imgs/insurance-new/icon-close-hover.png) no-repeat center / 100% 100%;
              }
            }
            .item-img-box{
              position: relative;
              font-size: 0;
              .item-img{
                width: 140px;
                height: 90px;
                border-radius: 2px;
              }
              .item-type{
                position: absolute;
                left: 0;
                bottom: 0;
                height: 20px;
                padding: 0 6px;
                font-size: 12px;
                color: #fff;
                background: rgba(47, 51, 61, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
                &::after{
                  content: "";
                  position: absolute;
                  right: -6px;
                  top: 0;
                  width: 0;
                  height: 0;
                  border-width: 10px 3px 10px 3px;
                  border-style: solid;
                  border-color: transparent transparent rgba(47, 51, 61, 0.6) rgba(47, 51, 61, 0.6);
                }
              }
              .review-box{
                cursor: pointer;
                position: absolute;
                z-index: 4;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                background: rgba(47, 51, 61, 0.6);
                display: flex;
                align-items: center;
                justify-content: center;
                opacity: 0;
                &:hover{
                  opacity: 1;
                }
                .review-icon{
                  width: 14px;
                  height: 14px;
                  margin-right: 4px;
                }
                .review-label{
                  color: #fff;
                  font-size: 14px;
                }
              }
            }
            .item-name{
              margin-top: 16px;
              font-size: 16px;
              color: #444444;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            /deep/ .el-loading-mask{
              z-index: 1;
            }
          }
          .upload-new-item{
            cursor: pointer;
            width: 160px;
            height: 146px;
            display: flex;
            align-items: center;
            flex-direction: column;
            padding-top: 32px;
            margin-right: 34px;
            margin-bottom: 34px;
            background: #F4FAFF;
            border: 1px dashed rgba(89, 159, 255, 0.4);
            border-radius: 2px;
            .add-icon{
              width: 24px;
              height: 24px;
              margin-bottom: 20px;
            }
            .upload-label{
              color: #599FFF;
              font-size: 16px;
              margin-bottom: 8px;
            }
            .upload-tips{
              color: #91999F;
              font-size: 12px;
              line-height: 17px;
              text-align: center;
            }
          }
        }

      }
    }

  }

  .dialog-footer{
    height: 80px;
    display: flex;
    align-items: center;
    padding: 0 24px;
    border-top: 1px solid #E9EEF2;
    .tips{
      display: flex;
      align-items: center;
      flex-grow: 1;
      .icon{
        width: 16px;
        margin-right: 3px;
      }
      .text{
        font-size: 14px;
        color: #5F666E;
      }
    }
    .btn-box{
      flex-shrink: 0;
      display: flex;
      align-items: center;
      .clear-btn{
        width: 116px;
        height: 48px;
        border-radius: 4px;
        border: 1px solid #C9CDD1;
        color: #5F666E;
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        outline: none;
        background: #fff;
        cursor: pointer;
      }
      .save-btn{
        width: 116px;
        height: 48px;
        border-radius: 4px;
        border: none;
        color: #fff;
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        outline: none;
        background: #599FFF;
        cursor: pointer;
        margin-left: 16px;
        &[disabled]{
          background: #DEE2E6;
          cursor: not-allowed;
        }
      }
    }
  }

  /deep/ #ocr-review-box {
    z-index: 3000 !important;
     .el-dialog {
      z-index: 3000 !important;
      position: absolute;
      left: 50%;
      top: 15% !important;
      width: 50%;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
      background: #fff;
      border-radius: 2px;
    }
    .el-dialog__header {
      display: block;
    }
    .el-dialog__body {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 30px 20px;
      img {
        max-width: 100%;
        width: 100%;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/insurance/components/insurance-ocr-dialog.vue